import { FocusContext, useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import { useVirtualization } from "./hooks/useVirtualization";
import { getModelConfig } from "../utils/models";
import { SECTION_TYPES } from "./constants/event";
import EventCardEPG from "./EPGEventCard";
import EPGSportCard from "./EPGSportCard";
import EPGLeagueCard from "./EPGLeagueCard";
import EPGPartnerCard from "./EPGPartnerCard";
import { scrollIntoViewWithinContainer } from "./utils/shared/scrollIntoView";
import "./epg.scss";

const EPGSectionRow = ({ items, title, rowId, rowType, virtualizationParams, onEnterPress }) => {
    const { ref, focusKey } = useFocusable({
        onFocus: () => {
            if (ref.current) {
                if (getModelConfig().epg.customScrollBehavior) {
                    scrollIntoViewWithinContainer(ref.current, 'scrollingRows');
                } else {
                    ref.current.scrollIntoView({
                        behavior: getModelConfig().epg.scrollBehavior,
                        block: "nearest",
                        inline: "nearest",
                    });
                }
            }
        },
    });
    const { scrollingRef, contentStyle, virtualItems, onItemFocus } = useVirtualization({
        items,
        ...virtualizationParams,
    });

    const onAssetFocus = (focusProps) => {
        onItemFocus(focusProps);
    };

    const rowClassName = rowType === SECTION_TYPES.EVENTS ? "sectionRowWrapper" : "shortcutRowWrapper";

    const renderCard = (item, index) => {
        switch (rowType) {
            case SECTION_TYPES.EVENTS:
                return <EventCardEPG event={item} key={item.id} index={index} rowId={rowId} onFocus={onAssetFocus} onEnterPress={onEnterPress} />;
            case SECTION_TYPES.SPORTS:
                return <EPGSportCard sport={item} key={item.id} index={index} rowId={rowId} onFocus={onAssetFocus} onEnterPress={onEnterPress} />;
            case SECTION_TYPES.LEAGUES:
                return <EPGLeagueCard league={item} key={item.id} index={index} rowId={rowId} onFocus={onAssetFocus} onEnterPress={onEnterPress} />;
            case SECTION_TYPES.PARTNERS:
                return <EPGPartnerCard partner={item} key={item.id} index={index} rowId={rowId} onFocus={onAssetFocus} onEnterPress={onEnterPress} />;
            default:
                return null;
        }
    };

    return (
        <FocusContext.Provider value={focusKey}>
            <div ref={ref} className={`sectionContainer ${rowClassName}`}>
                <h2 className="rowTitle">{title}</h2>
                <div ref={scrollingRef} className="sectionRowScrollingWrapper">
                    <div className="sectionRowScrollingContent" style={contentStyle}>
                        {virtualItems.map(({ item, index }) => renderCard(item, index))}
                    </div>
                </div>
            </div>
        </FocusContext.Provider>
    );
};

export default EPGSectionRow;
